import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import esCommon from './locales/es/common.json'
import esLayout from './locales/es/layout.json'
import esAssistants from './locales/es/assistants.json'
import esCalls from './locales/es/calls.json'
import esStatistics from './locales/es/statistics.json'
import esConversations from './locales/es/conversations.json'
import esUsers from './locales/es/users.json'
import esContacts from './locales/es/contacts.json'
import esVectorstores from './locales/es/vectorstores.json'
import esServers from './locales/es/servers.json'
import esActivity from './locales/es/activity.json'
import esNotifications from './locales/es/notifications.json'
import caCommon from './locales/ca/common.json'
import caLayout from './locales/ca/layout.json'
import caAssistants from './locales/ca/assistants.json'
import caCalls from './locales/ca/calls.json'
import caStatistics from './locales/ca/statistics.json'
import caConversations from './locales/ca/conversations.json'
import caUsers from './locales/ca/users.json'
import caContacts from './locales/ca/contacts.json'
import caVectorstores from './locales/ca/vectorstores.json'
import caServers from './locales/ca/servers.json'
import caActivity from './locales/ca/activity.json'
import caNotifications from './locales/ca/notifications.json'
import enCommon from './locales/en/common.json'
import enLayout from './locales/en/layout.json'
import enAssistants from './locales/en/assistants.json'
import enCalls from './locales/en/calls.json'
import enStatistics from './locales/en/statistics.json'
import enConversations from './locales/en/conversations.json'
import enUsers from './locales/en/users.json'
import enContacts from './locales/en/contacts.json'
import enVectorstores from './locales/en/vectorstores.json'
import enServers from './locales/en/servers.json'
import enActivity from './locales/en/activity.json'
import enNotifications from './locales/en/notifications.json'

export const SUPPORTED_LANGUAGES = ['es', 'ca', 'en']
export const DEFAULT_LANGUAGE = 'es'
export const LANGUAGE_STORAGE_KEY = 'gsti_lang'

const storedLang = (() => {
  try {
    const value = window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
    return SUPPORTED_LANGUAGES.includes(value) ? value : DEFAULT_LANGUAGE
  } catch {
    return DEFAULT_LANGUAGE
  }
})()

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { common: esCommon, layout: esLayout, assistants: esAssistants, calls: esCalls, statistics: esStatistics, conversations: esConversations, users: esUsers, contacts: esContacts, vectorstores: esVectorstores, servers: esServers, activity: esActivity, notifications: esNotifications },
      ca: { common: caCommon, layout: caLayout, assistants: caAssistants, calls: caCalls, statistics: caStatistics, conversations: caConversations, users: caUsers, contacts: caContacts, vectorstores: caVectorstores, servers: caServers, activity: caActivity, notifications: caNotifications },
      en: { common: enCommon, layout: enLayout, assistants: enAssistants, calls: enCalls, statistics: enStatistics, conversations: enConversations, users: enUsers, contacts: enContacts, vectorstores: enVectorstores, servers: enServers, activity: enActivity, notifications: enNotifications },
    },
    lng: storedLang,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: 'common',
    ns: ['common', 'layout', 'assistants', 'calls', 'statistics', 'conversations', 'users', 'contacts', 'vectorstores', 'servers', 'activity', 'notifications'],
    interpolation: { escapeValue: false },
  })

export default i18n
